<template>
  <select class="form-control" v-model="localState">
    <option
      v-for="(state, abbreviation) in states"
      :key="abbreviation"
      :value="abbreviation"
      >{{ abbreviation }} - {{ state }}</option
    >
  </select>
</template>
<script>
import { countriesCollection } from "@/firebase";
export default {
  props: {
    country: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    }
  },
  methods: {
    getStates() {
      if (this.country) {
        const self = this;
        countriesCollection
          .doc(this.country.toLowerCase())
          .get()
          .then(function(doc) {
            let country = doc.data();
            //console.log(country);
            //return country.states;
            self.states = country.states;
          })
          .catch(function(err) {
            console.log(err);
            let message = self.$t("message.state_error");
            self.flashMessage.show({
              status: "error",
              message: self.$options.filters.capitalize(message)
            });
            //return [];
          });
      }
      //return [];
    }
  },
  computed: {
    /*states:{
                get: function(){
                    console.log("computed", this.localStates);
                    return this.localStates;
                },
                set: function(s){
                    this.localState = s;
                }
            },*/
    localState: {
      get() {
        return this.value;
      },
      set(localState) {
        this.$emit("input", localState);
      }
    }
  },
  mounted() {
    if (this.country) {
      this.getStates();
    }
  },
  watch: {
    country() {
      //console.log("country:", c,n);
      this.getStates();
    }
  },
  data() {
    return {
      states: {}
    };
  }
};
</script>
